import RjLogo from "@/assets/svg/rj-logo-full.svg?react";
import LocaleToggle from "@/components/ui/locale-toggle";
import ModeToggle from "@/components/ui/mode-toggle";

function Header() {
	return (
		<header className="bg-secondary">
			<div className="container flex h-16 items-center justify-between">
				<div>
					<RjLogo className="h-auto w-28" />
				</div>
				<div className="flex items-center gap-x-4">
					<LocaleToggle />
					<ModeToggle />
				</div>
			</div>
		</header>
	);
}

export default Header;
